$(function () {
    $(".js-dataTable").dataTable({
        processing: true,
        responsive: true,
        deferRender: true,
        paging: true,
        pagingType: "full_numbers",
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ordering: false,
        autoWidth: false,
        dom: 'lfrtip',
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.12.1/i18n/pt-BR.json"
        },
        columnDefs: [
            { responsivePriority: 1, targets: 0 },
            { responsivePriority: 2, targets: -1 }
        ],
    });

    $(".js-dataTable-group").dataTable({
        processing: true,
        responsive: true,
        deferRender: true,
        paging: true,
        pagingType: "full_numbers",
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ordering: false,
        autoWidth: false,
        dom: 'lfrtip',
        rowGroup: {
            dataSrc: 2,
            startRender: function (rows, group) {
                return `Grupo: <strong>${group}</strong> (${rows.count()} itens)`;
            },
        },
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.12.1/i18n/pt-BR.json"
        },
        columnDefs: [
            { responsivePriority: 1, targets: 0 },
            { responsivePriority: 2, targets: -1 }
        ],
    });

    $(".js-dataTable-basic").dataTable({
        processing: true,
        responsive: true,
        deferRender: true,
        ordering: false,
        autoWidth: false,
        dom: 't',
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.12.1/i18n/pt-BR.json"
        },
        columnDefs: [
            { responsivePriority: 1, targets: 0 },
            { responsivePriority: 2, targets: -1 }
        ],
    });
});

function createDataTable(tableName, pagelength = 10, showfilter = false, scrollx = false) {
    dataTable = $("#" + tableName).dataTable({
        processing: true,
        responsive: true,
        deferRender: true,
        ordering: true,
        paging: true,
        pagingType: "full_numbers",
        lengthMenu: [25, 50, 100],
        pageLength: pagelength,
        autoWidth: false,
        scrollX: scrollx,
        dom: 'lfrtip',
        language: {
            url: "https://cdn.datatables.net/plug-ins/1.12.1/i18n/pt-BR.json"
        },
        if(showfilter) {
            buttons: [
                'searchPanes'
            ]
        },
    });
    return dataTable;
}

function formatarData(data) {
    if (!data || typeof data !== "string") return null;

    let dt = null;
    
    // 1️⃣ Tenta interpretar como ISO (ex: 2025-10-23, 2025-10-23T15:00)
    dt = luxon.DateTime.fromISO(data);
    if (dt.isValid) return dt.toFormat('dd/MM/yy');

    // 2️⃣ Tenta interpretar como dd/MM/yyyy (ex: 23/10/2025)
    dt = luxon.DateTime.fromFormat(data, 'dd/MM/yyyy');
    if (dt.isValid) return dt.toFormat('dd/MM/yy');

    // 3️⃣ Tenta interpretar como MM/dd/yyyy (ex: 10/23/2025)
    dt = luxon.DateTime.fromFormat(data, 'MM/dd/yyyy');
    if (dt.isValid) return dt.toFormat('dd/MM/yy');

    // 4️⃣ Caso nada funcione, retorna null
    return null;
}

